<template>
<div style="width:100%;height:100%;">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && Object.keys(userMacInfo).length===0">{{ $t('gateway.no_gateway_available_hint' )}}</span>

  <span class="centerized title grey--text text-xs-center" v-else-if="!loading && filteredMac.length===0">{{ $t('gateway.no_gateway_matched' )}}</span>

  <l-map ref="myMap" :center="center" :zoom="zoom" @update:zoom="zoomUpdated" @update:center="centerUpdated" @update:bounds="boundsUpdated" v-else-if="!loading">
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <gateway-map-marker v-for="mac in filteredMac" :key="mac.mac" :data="mac" @detail="onGatewayDetail"></gateway-map-marker>
  </l-map>

  <gateway-chart v-if="dialogChart" v-model="dialogChart" :mac="dialogChartMac" :type="dialogChartType" :name="dialogChartName"></gateway-chart>

  <gateway-detail-item v-if="dialogDetail" v-model="dialogDetail" :data="dialogDetailData" :itemCommands="itemCommands" @edit="dialogDetail=false;dialogEditor=true" @toast="val=>$emit('toast',val)"></gateway-detail-item>

  <gateway-editor v-if="dialogEditor" v-model="dialogEditor" :data="dialogDetailData" @toast="val=>$emit('toast',val)"></gateway-editor>

  <progress-dialog v-if="loading">{{ $t('loading') }}</progress-dialog>

</div>
</template>

<script>
import Gateway from '@/components/gateway/Gateway'
import GatewayMapMarker from '@/components/gateway/MapMarker'

import {
  LMap,
  LTileLayer
} from 'vue2-leaflet';

import {
  Icon
} from 'leaflet';

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: 'GatewayMap',
  mixins: [Gateway],
  components: {
    LMap,
    LTileLayer,
    'gateway-map-marker': GatewayMapMarker
  },
  data() {
    return {
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 12,
      bounds: null,
      center: [25.014841, 121.218676] // Luffanet Headquarter
    }
  },
  watch: {
    filteredMac(val, old) {
      if (old.length != val.length) {
        //console.log(`${old.length} --> ${val.length}`);
        if (val.length > 0) {
          let bounds = val.map(item => item.latlng);
          this.$nextTick(() => {
            this.$refs.myMap.fitBounds(bounds);
          });
        }
      }
    }
  },
  computed: {
    macList() {
      let data = Object.values(this.userMacInfo || {}) || [];
      data.forEach(item => {
        item.latlng = (item.map || '').split(',');
      });
      return data.filter(item => item.latlng[0] && item.latlng[1]);
    },
    filteredMac() {
      let data = this.macList;
      if (this.searchKeyword) {
        data = data.filter(item => item.map).filter(item => [
          item.mac,
          item.uuid || '',
          item.address || '',
          item.hostname || '',
          item.map || '',
          (item.firmware || {}).version || ''
        ].join('#').toLowerCase().indexOf(this.searchKeyword.toLowerCase()) != -1);
      }
      return data;
    }
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    }
  },
  mounted() {
    if (this.filteredMac.length > 0) {
      let bounds = this.filteredMac.map(item => item.latlng);
      this.$nextTick(() => {
        this.$refs.myMap.fitBounds(bounds);
      });
    }
  }
}
</script>

<style>
@import 'leaflet/dist/leaflet.css';

.leaflet-pane {
  z-index: 0;
}

.leaflet-top,
.leaflet-bottom {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/gateway/Map.vue